import React from 'react';
import classNames from 'classnames';
import styles from "./BarLoader.module.scss"

/**
 * @deprecated - DONT USE IN NEW FEATURES
 */
const BarLoader = ({className}) => (
        <div className={classNames(styles["loading-bar"], className)}>
            <div className={styles["the-blue"]}/>
        </div>
    );

export default BarLoader